module.exports = __webpack_public_path__ + "img/blocked.43e1a586.svg";